import FlexRow from "Components/FlexRow";
import Box from "Components/Box";
import LoginForm from "Features/Authentication/Components/LoginForm";
import AnotherSolutionIcon from "../Assets/SVG/AnotherSolutionIcon";

const SignIn = () => {
    
    return (
        <FlexRow className={"h-100"} justify={"center"} align={"center"}>
            <div style={{width: 400}}>
                <Box>
                    <AnotherSolutionIcon width={200} style={{paddingBottom: 20}} />
                    <LoginForm />
                </Box>
            </div>
        </FlexRow>
    )
}

export default SignIn
